import React, { useContext } from "react";
import { FormattedMessage } from "react-intl";
import Tooltip from "../RankingTooltips/RankingTooltipContainer";
import { IsMobileContext } from "../isMobileContext";
import { GameListSwitcherMobile } from "../Common/Dropdowns";

const tabs = [
  {
    status: "live",
    scope: "my",
    formattedMessageId: "ranking.myLiveGames"
  },
  {
    status: "live",
    scope: "all",
    formattedMessageId: "ranking.allLiveGames"
  },
  {
    status: "finished",
    scope: "my",
    formattedMessageId: "ranking.myFinishedGames"
  },
  {
    status: "finished",
    scope: "all",
    formattedMessageId: "ranking.allFinishedGames"
  },
  {
    status: "pre-live",
    scope: "admin",
    text: "Pre-Live"
  },
  {
    status: "in-registration",
    scope: "admin",
    text: "In-Registration"
  }
];

const GameListSwitcher = ({
  onFetchGames,
  currentKey,
  showPreLive,
  isLoggedIn
}) => {

  const ctx = useContext(IsMobileContext);
  const filterdTabs = tabs.filter(e => {switch (e.scope) {
      case "admin":
        return showPreLive;
      case "my":
        return isLoggedIn;
      default:
        return !e.hideOnLogin || !isLoggedIn;
    }
  });


  if(ctx.isMobile){
    return(
    <GameListSwitcherMobile
      currentKey={currentKey}
      onFetchGames={onFetchGames}
      options={filterdTabs}
    />
)
  }

  return (
    <div className="games-list-switcher">
      <Tooltip id={"tabs"} />
      {filterdTabs
        .map(e => (
          <MenuTab
            key={e.scope + e.status}
            active={
              e.status === currentKey.status && e.scope === currentKey.scope
            }
            onClick={() => onFetchGames(e.status, e.scope)}
            {...e}
          />
        ))}
    </div>
  );
};

const MenuTab = ({ status, onClick, active, text, formattedMessageId }) => (
  <div
    className={`games-list-switcher__tab games-list-switcher__tab--${status} ${
      active ? "games-list-switcher__tab--active" : ""
    } `}
  >
    <button
      className="games-list-switcher__button"
      onClick={onClick}
      disabled={active}
    >
      <span className="glyphicon glyphicon-chevron-up" />
      {text}
      {formattedMessageId ? <FormattedMessage id={formattedMessageId} /> : null}
    </button>
  </div>
);

export default GameListSwitcher;
